import React from 'react';
import { Text, TextProps } from '@opendoor/bricks/core';

/** TODO: Add documentation */
export const PrivacyPolicyDescription: React.FC<TextProps & { ctaText: string }> = ({
  ctaText,
  ...props
}) => (
  <Text fontSize="s00" lineHeight="s00" color="neutrals70" {...props}>
    By pressing "{ctaText}", you consent to recieve marketing calls and texts from Opendoor,
    including by automated means. You may opt-out at any time and consent is not a condition of
    purchase.
  </Text>
);
